module.exports = __webpack_public_path__ + "img/reverse_left.13587fa8.jpg";